"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var echarts = _interopRequireWildcard(require("echarts"));
var _bi = require("@/api/bi");
var _timeAxis = require("./timeAxis");
var _baseInfo = _interopRequireDefault(require("./components/baseInfo"));
var _gridMenu = _interopRequireDefault(require("./components/gridMenu"));
var _visitChart = _interopRequireDefault(require("./components/visitChart"));
var _userChart = _interopRequireDefault(require("./components/userChart"));
var _permission = require("@/utils/permission");
var systemConfigApi = _interopRequireWildcard(require("@/api/systemConfig"));
var _list = _interopRequireDefault(require("@/views/content/resource/list.vue"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 权限判断函数
var _default = exports.default = {
  components: {
    baseInfo: _baseInfo.default,
    gridMenu: _gridMenu.default,
    visitChart: _visitChart.default,
    userChart: _userChart.default,
    list: _list.default
  },
  name: 'Dashboard',
  data: function data() {
    return {
      customConfig: {},
      authStatus: null,
      authHost: '',
      authQueryStatus: false,
      timeRange: 'year',
      loading: false,
      // 各个模块的加载状态
      productRankLoading: false,
      trendProductRankLoading: false,
      userGrowthLoading: false,
      // 累计总览
      overviewData: {
        totalSales: 0,
        totalOrderCount: 0,
        totalUserCount: 0,
        totalPayUserCount: 0,
        totalPageviews: 0
      },
      // 销售趋势图旁核心汇总（跟随 timeRange）
      coreData: {
        todayOrderCount: 0,
        todaySales: 0,
        todayPayUserCount: 0
      },
      // 图表数据
      productRank: [],
      trendProductRank: [],
      userGrowth: [],
      salesRegion: [],
      salesCategory: [],
      // 图表实例
      userChart: null,
      regionChart: null,
      categoryChart: null
    };
  },
  computed: {
    displayRankList: function displayRankList() {
      var list = (this.trendProductRank || []).slice(0, 10).map(function (row) {
        return _objectSpread(_objectSpread({}, row), {}, {
          isPlaceholder: false
        });
      });
      while (list.length < 10) {
        list.push({
          isPlaceholder: true
        });
      }
      return list;
    }
  },
  mounted: function mounted() {
    var _this = this;
    systemConfigApi.customConfig().then(function (data) {
      _this.customConfig = data;
      console.log(_this.customConfig.packages);
      if (_this.customConfig.packages != '4') {
        _this.initDashboard();
        _this.$nextTick(function () {
          window.addEventListener('resize', _this.handleResize);
          if (window.visualViewport) {
            window.visualViewport.addEventListener('resize', _this.handleResize);
          }
          _this.bindResizeObserver();
          _this.handleResize();
        });
      }
    });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
    if (window.visualViewport) {
      window.visualViewport.removeEventListener('resize', this.handleResize);
    }
    this.unbindResizeObserver();
    this.disposeCharts();
  },
  methods: {
    checkPermi: _permission.checkPermi,
    // 初始化仪表板
    initDashboard: function () {
      var _initDashboard = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _this2 = this;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.loading = true;
              _context.prev = 1;
              // 先销毁所有图表
              this.disposeCharts();

              // 并行加载所有数据
              _context.next = 5;
              return Promise.all([this.loadOverviewData(), this.loadCoreData(), this.loadTrendProductRank(), this.loadUserGrowth(), this.loadSalesRegion(), this.loadSalesCategory()]);
            case 5:
              _context.next = 11;
              break;
            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](1);
              console.error('加载数据失败:', _context.t0);
              this.$message.error('数据加载失败');
            case 11:
              _context.prev = 11;
              this.loading = false;
              this.$nextTick(function () {
                _this2.handleResize();
                // 等 flex 高度结算后再 resize 一次，避免图表底部被裁切
                setTimeout(function () {
                  return _this2.handleResize();
                }, 80);
              });
              return _context.finish(11);
            case 15:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[1, 7, 11, 15]]);
      }));
      function initDashboard() {
        return _initDashboard.apply(this, arguments);
      }
      return initDashboard;
    }(),
    // 第二行时间切换已并入公共 timeRange
    formatRankValue: function formatRankValue(amount) {
      return Number(amount || 0).toLocaleString('zh-CN', {
        maximumFractionDigits: 0
      });
    },
    // 加载累计总览卡片
    loadOverviewData: function () {
      var _loadOverviewData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var response;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return (0, _bi.getOverviewCards)();
            case 3:
              response = _context2.sent;
              this.overviewData = {
                totalSales: response && response.totalSales || 0,
                totalOrderCount: response && response.totalOrderCount || 0,
                totalUserCount: response && response.totalUserCount || 0,
                totalPayUserCount: response && response.totalPayUserCount || 0,
                totalPageviews: response && response.totalPageviews || 0
              };
              _context2.next = 11;
              break;
            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](0);
              console.error('加载总览数据失败:', _context2.t0);
              this.$message.error('总览数据加载失败');
            case 11:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[0, 7]]);
      }));
      function loadOverviewData() {
        return _loadOverviewData.apply(this, arguments);
      }
      return loadOverviewData;
    }(),
    // 加载销售趋势图旁核心汇总
    loadCoreData: function () {
      var _loadCoreData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var response;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return (0, _bi.getCoreData)(this.timeRange);
            case 3:
              response = _context3.sent;
              this.coreData = {
                todayOrderCount: response && response.todayOrderCount || 0,
                todaySales: response && response.todaySales || 0,
                todayPayUserCount: response && response.todayPayUserCount || 0
              };
              _context3.next = 11;
              break;
            case 7:
              _context3.prev = 7;
              _context3.t0 = _context3["catch"](0);
              console.error('加载核心数据失败:', _context3.t0);
              this.$message.error('核心数据加载失败');
            case 11:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[0, 7]]);
      }));
      function loadCoreData() {
        return _loadCoreData.apply(this, arguments);
      }
      return loadCoreData;
    }(),
    // 加载商品排行榜（跟随公共时间范围）
    loadTrendProductRank: function () {
      var _loadTrendProductRank = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var response;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              this.trendProductRankLoading = true;
              _context4.prev = 1;
              _context4.next = 4;
              return (0, _bi.getProductRank)(this.timeRange);
            case 4:
              response = _context4.sent;
              this.trendProductRank = response || [];
              _context4.next = 12;
              break;
            case 8:
              _context4.prev = 8;
              _context4.t0 = _context4["catch"](1);
              console.error('加载商品排行榜失败:', _context4.t0);
              this.$message.error('商品排行榜加载失败');
            case 12:
              _context4.prev = 12;
              this.trendProductRankLoading = false;
              return _context4.finish(12);
            case 15:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[1, 8, 12, 15]]);
      }));
      function loadTrendProductRank() {
        return _loadTrendProductRank.apply(this, arguments);
      }
      return loadTrendProductRank;
    }(),
    // 兼容旧方法名
    loadProductRank: function () {
      var _loadProductRank = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              return _context5.abrupt("return", this.loadTrendProductRank());
            case 1:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function loadProductRank() {
        return _loadProductRank.apply(this, arguments);
      }
      return loadProductRank;
    }(),
    // 加载用户增长数据
    loadUserGrowth: function () {
      var _loadUserGrowth = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var _this3 = this;
        var response;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              this.userGrowthLoading = true;
              _context6.prev = 1;
              _context6.next = 4;
              return (0, _bi.getUserGrowth)(this.timeRange);
            case 4:
              response = _context6.sent;
              this.userGrowth = response || [];

              // 数据加载完成后重新初始化图表
              this.$nextTick(function () {
                if (_this3.userChart) {
                  _this3.userChart.dispose();
                  _this3.userChart = null;
                }
                _this3.initUserChart();
              });
              _context6.next = 13;
              break;
            case 9:
              _context6.prev = 9;
              _context6.t0 = _context6["catch"](1);
              console.error('加载用户增长数据失败:', _context6.t0);
              this.$message.error('用户增长数据加载失败');
            case 13:
              _context6.prev = 13;
              this.userGrowthLoading = false;
              return _context6.finish(13);
            case 16:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this, [[1, 9, 13, 16]]);
      }));
      function loadUserGrowth() {
        return _loadUserGrowth.apply(this, arguments);
      }
      return loadUserGrowth;
    }(),
    // 加载销售地区分布
    loadSalesRegion: function () {
      var _loadSalesRegion = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var _this4 = this;
        var response;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.prev = 0;
              _context7.next = 3;
              return (0, _bi.getSalesRegionDistribution)(this.timeRange);
            case 3:
              response = _context7.sent;
              this.salesRegion = response || [];
              this.$nextTick(function () {
                if (_this4.regionChart) {
                  _this4.regionChart.dispose();
                  _this4.regionChart = null;
                }
                _this4.initRegionChart();
              });
              _context7.next = 12;
              break;
            case 8:
              _context7.prev = 8;
              _context7.t0 = _context7["catch"](0);
              console.error('加载销售地区失败:', _context7.t0);
              this.$message.error('销售地区数据加载失败');
            case 12:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this, [[0, 8]]);
      }));
      function loadSalesRegion() {
        return _loadSalesRegion.apply(this, arguments);
      }
      return loadSalesRegion;
    }(),
    // 加载销售分类分布
    loadSalesCategory: function () {
      var _loadSalesCategory = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var _this5 = this;
        var response;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.prev = 0;
              _context8.next = 3;
              return (0, _bi.getSalesCategoryDistribution)(this.timeRange);
            case 3:
              response = _context8.sent;
              this.salesCategory = response || [];
              this.$nextTick(function () {
                if (_this5.categoryChart) {
                  _this5.categoryChart.dispose();
                  _this5.categoryChart = null;
                }
                _this5.initCategoryChart();
              });
              _context8.next = 12;
              break;
            case 8:
              _context8.prev = 8;
              _context8.t0 = _context8["catch"](0);
              console.error('加载销售分类失败:', _context8.t0);
              this.$message.error('销售分类数据加载失败');
            case 12:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this, [[0, 8]]);
      }));
      function loadSalesCategory() {
        return _loadSalesCategory.apply(this, arguments);
      }
      return loadSalesCategory;
    }(),
    // 刷新单个模块的方法
    refreshProductRank: function () {
      var _refreshProductRank = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return this.loadProductRank();
            case 2:
              this.$message.success('商品排行榜已刷新');
            case 3:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function refreshProductRank() {
        return _refreshProductRank.apply(this, arguments);
      }
      return refreshProductRank;
    }(),
    refreshUserGrowth: function () {
      var _refreshUserGrowth = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return this.loadUserGrowth();
            case 2:
              this.$message.success('用户增长数据已刷新');
            case 3:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
      function refreshUserGrowth() {
        return _refreshUserGrowth.apply(this, arguments);
      }
      return refreshUserGrowth;
    }(),
    // 刷新所有数据
    refreshData: function () {
      var _refreshData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return this.initDashboard();
            case 2:
              this.$message.success('所有数据已刷新');
            case 3:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
      function refreshData() {
        return _refreshData.apply(this, arguments);
      }
      return refreshData;
    }(),
    // 时间范围切换
    handleTimeRangeChange: function handleTimeRangeChange() {
      this.initDashboard();
    },
    // 初始化图表
    initCharts: function initCharts() {
      this.initUserChart();
      this.initRegionChart();
      this.initCategoryChart();
    },
    // 通用销售饼图（地区 / 分类）；无数据时画灰色空环
    buildSalesPieOption: function buildSalesPieOption(list, seriesName) {
      var hasData = list && list.length > 0;
      var pieData = hasData ? list.map(function (item) {
        return {
          name: item.name,
          value: Number(item.value || 0)
        };
      }) : [{
        name: '暂无数据',
        value: 1,
        itemStyle: {
          color: '#F2F2F2'
        }
      }];
      return {
        color: ['#5B8FF9', '#5AD8A6', '#5D7092', '#F6BD16', '#E8684A', '#6DC8EC', '#9270CA', '#FF9D4D', '#269A99', '#FF99C3'],
        tooltip: {
          show: hasData,
          trigger: 'item',
          formatter: function formatter(params) {
            var amount = Number(params.value || 0).toLocaleString('zh-CN', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            });
            return "".concat(params.seriesName, "<br/>").concat(params.name, ": \xA5").concat(amount, " (").concat(params.percent, "%)");
          },
          backgroundColor: 'rgba(255, 255, 255, 0.95)',
          borderColor: '#EBEEF5',
          borderWidth: 1,
          textStyle: {
            color: '#606266',
            fontSize: 12
          },
          extraCssText: 'box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);'
        },
        legend: {
          show: hasData,
          type: 'plain',
          orient: 'horizontal',
          left: 'center',
          bottom: 0,
          width: '92%',
          textStyle: {
            color: '#606266',
            fontSize: 12
          },
          itemWidth: 10,
          itemHeight: 10,
          itemGap: 10,
          data: hasData ? list.map(function (item) {
            return item.name;
          }) : []
        },
        graphic: hasData ? [] : [{
          type: 'text',
          left: 'center',
          top: 'middle',
          style: {
            text: '暂无数据',
            fill: 'rgba(0,0,0,0.15)',
            fontSize: 14
          }
        }],
        series: [{
          name: seriesName,
          type: 'pie',
          radius: ['36%', '56%'],
          center: ['50%', '40%'],
          avoidLabelOverlap: true,
          silent: !hasData,
          itemStyle: {
            borderRadius: hasData ? 6 : 0,
            borderColor: '#fff',
            borderWidth: 2
          },
          label: {
            show: false
          },
          labelLine: {
            show: false
          },
          emphasis: {
            scale: hasData,
            label: {
              show: false
            }
          },
          data: pieData
        }]
      };
    },
    initRegionChart: function initRegionChart() {
      if (!this.$refs.regionChart) return;
      if (!this.regionChart) {
        this.regionChart = echarts.init(this.$refs.regionChart);
      }
      this.regionChart.setOption(this.buildSalesPieOption(this.salesRegion, '销售地区'), true);
    },
    initCategoryChart: function initCategoryChart() {
      if (!this.$refs.categoryChart) return;
      if (!this.categoryChart) {
        this.categoryChart = echarts.init(this.$refs.categoryChart);
      }
      this.categoryChart.setOption(this.buildSalesPieOption(this.salesCategory, '销售分类'), true);
    },
    buildUserGrowthChartData: function buildUserGrowthChartData() {
      var _fillTimeAxisSeries = (0, _timeAxis.fillTimeAxisSeries)(this.userGrowth, this.timeRange, function (item) {
          return {
            keySource: item.registerDate,
            values: {
              count: Number(item.newUserCount || 0)
            }
          };
        }),
        axis = _fillTimeAxisSeries.axis,
        buckets = _fillTimeAxisSeries.buckets;
      var xData = axis.labels;
      var yData = axis.keys.map(function (k) {
        return buckets[k].count || 0;
      });
      return {
        xData: xData,
        yData: yData,
        hasRealData: yData.some(function (v) {
          return v > 0;
        }),
        rotate: axis.rotate || 0
      };
    },
    // 用户增长图表：绿色平滑面积图
    initUserChart: function initUserChart() {
      if (!this.$refs.userChart) return;
      if (!this.userChart) {
        this.userChart = echarts.init(this.$refs.userChart);
      }
      var _this$buildUserGrowth = this.buildUserGrowthChartData(),
        xData = _this$buildUserGrowth.xData,
        yData = _this$buildUserGrowth.yData,
        hasRealData = _this$buildUserGrowth.hasRealData,
        rotate = _this$buildUserGrowth.rotate;

      // 今天等仅 1 个点：左右留空补成水平线，日期标签居中
      var singleDayCentered = false;
      if (xData.length === 1) {
        var label = xData[0];
        var val = yData[0];
        xData = ['', label, ''];
        yData = [val, val, val];
        singleDayCentered = true;
      }
      var fewPoints = singleDayCentered || xData.length <= 2;
      var dataMax = hasRealData ? Math.max.apply(Math, _toConsumableArray(yData).concat([0])) : 0;
      var axisMax = !hasRealData ? 10 : Math.max(Math.ceil(dataMax * 1.6), dataMax + 1);
      var option = {
        color: ['#52c41a'],
        tooltip: {
          show: hasRealData,
          trigger: 'axis',
          backgroundColor: '#fff',
          borderColor: '#f0f0f0',
          borderWidth: 1,
          padding: [10, 12],
          textStyle: {
            color: 'rgba(0,0,0,0.65)',
            fontSize: 12
          },
          extraCssText: 'border-radius: 4px; box-shadow: 0 2px 8px rgba(0,0,0,0.08);',
          axisPointer: {
            type: 'line',
            lineStyle: {
              color: 'rgba(0,0,0,0.25)',
              width: 1,
              type: 'solid'
            }
          },
          formatter: function formatter(params) {
            var item = Array.isArray(params) ? params[0] : params;
            if (!item) return '';
            var axisLabel = item.axisValue || (singleDayCentered ? xData[1] : '');
            if (!axisLabel) return '';
            var val = Number(item.value || 0).toLocaleString('zh-CN');
            return "".concat(axisLabel, "<br/>\u65B0\u589E\u7528\u6237\uFF1A").concat(val);
          }
        },
        grid: {
          left: 8,
          right: 12,
          top: 28,
          bottom: 8,
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: fewPoints,
          data: xData,
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            color: 'rgba(0,0,0,0.45)',
            fontSize: 11,
            rotate: rotate || 0,
            hideOverlap: true,
            margin: 10,
            // 单日：只显示中间日期，保证居中
            interval: singleDayCentered ? function (index) {
              return index === 1;
            } : 'auto',
            formatter: function formatter(val) {
              return val || '';
            }
          },
          splitLine: {
            show: false
          }
        },
        yAxis: {
          type: 'value',
          min: 0,
          max: axisMax,
          minInterval: 1,
          splitNumber: 3,
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            color: 'rgba(0,0,0,0.45)',
            fontSize: 10
          },
          splitLine: {
            show: false
          }
        },
        graphic: hasRealData ? [] : [{
          type: 'text',
          left: 'center',
          top: 'middle',
          style: {
            text: '暂无数据',
            fill: 'rgba(0,0,0,0.25)',
            fontSize: 14
          }
        }],
        series: [{
          name: '新增用户',
          type: 'line',
          smooth: !fewPoints,
          symbol: 'circle',
          showSymbol: true,
          // 今天单点：始终显示圆点；多日：仅非 0 点显示，避免全年零值铺一排绿点
          symbolSize: fewPoints ? hasRealData ? 8 : 0 : function (val) {
            return hasRealData && Number(val) > 0 ? 7 : 0;
          },
          data: yData,
          lineStyle: {
            width: 2,
            color: '#52c41a'
          },
          itemStyle: {
            color: '#52c41a',
            borderColor: '#fff',
            borderWidth: 1
          },
          areaStyle: hasRealData ? {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
              offset: 0,
              color: 'rgba(82, 196, 26, 0.35)'
            }, {
              offset: 1,
              color: 'rgba(82, 196, 26, 0.02)'
            }])
          } : {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
              offset: 0,
              color: 'rgba(82, 196, 26, 0.12)'
            }, {
              offset: 1,
              color: 'rgba(82, 196, 26, 0.02)'
            }])
          },
          emphasis: {
            focus: 'series',
            scale: true
          }
        }]
      };
      this.userChart.setOption(option, true);
    },
    // 工具方法
    formatMoney: function formatMoney(amount) {
      return Number(amount).toLocaleString('zh-CN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },
    formatNumber: function formatNumber(num) {
      return Number(num || 0).toLocaleString('zh-CN');
    },
    getRankClass: function getRankClass(index) {
      var classes = ['rank-number'];
      if (index === 0) classes.push('rank-gold');else if (index === 1) classes.push('rank-silver');else if (index === 2) classes.push('rank-bronze');
      return classes.join(' ');
    },
    tableRowClassName: function tableRowClassName(_ref) {
      var rowIndex = _ref.rowIndex;
      return rowIndex % 2 === 1 ? 'even-row' : '';
    },
    // 操作方法
    exportSalesData: function exportSalesData() {
      this.$message.info('导出功能开发中');
    },
    viewProductDetail: function viewProductDetail(product) {
      this.$message.info("\u67E5\u770B\u5546\u54C1\u8BE6\u60C5: ".concat(product.productName));
    },
    handleResize: function handleResize() {
      var _this6 = this;
      if (this._resizeRaf) cancelAnimationFrame(this._resizeRaf);
      this._resizeRaf = requestAnimationFrame(function () {
        if (_this6.userChart) _this6.userChart.resize();
        if (_this6.regionChart) _this6.regionChart.resize();
        if (_this6.categoryChart) _this6.categoryChart.resize();
        if (_this6.$refs.visitChart) _this6.$refs.visitChart.handleResize();
      });
    },
    bindResizeObserver: function bindResizeObserver() {
      var _this7 = this;
      if (typeof ResizeObserver === 'undefined' || !this.$el) return;
      this.unbindResizeObserver();
      this._resizeObserver = new ResizeObserver(function () {
        return _this7.handleResize();
      });
      this._resizeObserver.observe(this.$el);
    },
    unbindResizeObserver: function unbindResizeObserver() {
      if (this._resizeObserver) {
        this._resizeObserver.disconnect();
        this._resizeObserver = null;
      }
      if (this._resizeRaf) {
        cancelAnimationFrame(this._resizeRaf);
        this._resizeRaf = null;
      }
    },
    disposeCharts: function disposeCharts() {
      ;
      [this.userChart, this.regionChart, this.categoryChart].forEach(function (chart) {
        if (chart) chart.dispose();
      });
      this.userChart = null;
      this.regionChart = null;
      this.categoryChart = null;
    }
  }
};